import axios from "axios";

const api = axios.create({
  baseURL:
    process.env.VUE_APP_BASE_API_URL ||
    "https://api-profile.productscala.online/",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    console.log({ config });
    const token = localStorage.getItem("access_token");
    console.log({ token });
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        console.error("Unauthorized, redirecting to login...");
        // Tambahkan logika redirect ke login jika perlu
      }
    }
    return Promise.reject(error);
  }
);

export default api;
